import { mediaItems } from '@/mocks/homepage';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            视频漫评
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            哔咔动漫官方视频频道，深度漫评与盘点内容精彩呈现
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              {/* Thumbnail */}
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {/* Play button overlay */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 backdrop-blur-sm text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                {/* Duration */}
                <span className="absolute bottom-2 right-2 px-2 py-0.5 text-[10px] font-medium rounded bg-foreground-900/75 text-background-50 backdrop-blur-sm">
                  {item.duration}
                </span>
              </div>

              {/* Info */}
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-[11px] text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views} 次观看
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}